export default "__VITE_PUBLIC_ASSET__fb4076e6__"